import { IDifaUserBE } from '../interfaces/IDifaUserBE';
import { IImpersonation } from '../interfaces/IImpersonation';
import { IImpersonationDialogDataPipe } from '../interfaces/IImpersonation.module';
import { IPersistentFilterUpdateBody } from '../interfaces/IPersistentFilterUpdateBody';
import { IPersistentFilter } from '../interfaces/employee/IPersistentFilter';

export class SetUser {
  static readonly type = '[User] SetUser';
  constructor(public payload: IDifaUserBE) {}
}

export class Logout {
  static readonly type = '[User] Logout';
}

export class Login {
  static readonly type = '[User] Login';
}

export class LoadUserImpersonationData {
  static readonly type = '[User] LoadUserImpersonationData';
}

export class LoadImitableUsers {
  static readonly type = '[User] LoadImitableUsers';
}

export class LoadImpersonatingUsers {
  static readonly type = '[User] LoadImpersonatingUsers';
  constructor(public gid: string[]) {}
}

export class StartUserImpersonation {
  static readonly type = '[User] StartUserImpersonation';
  constructor(public imitableUser: IImpersonation) {}
}

export class StopUserImpersonation {
  static readonly type = '[User] StopUserImpersonation';
}

export class UpdateImpersonations {
  static readonly type = '[User] UpdateImpersonations';
  constructor(public dataPipe: IImpersonationDialogDataPipe) {}
}

export class LoadPersistentFilters {
  static readonly type = '[User] LoadPersistentFilters';
}

export class UpdatePersistentFilters {
  static readonly type = '[User] UpdatePersistentFilters';

  constructor(
    public persistentFilterBody: IPersistentFilterUpdateBody,
    public filterPropertyToUpdate: keyof IPersistentFilter,
  ) {}
}
